export function isValidMonthDayAndYear (month: number, day: number, year: number) {
    if (!day || !month || !year) return false
    const validMonth = month > 0 && month <= 12
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    const validYear = !isNaN(year)
    if (!validYear) return false
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
    if (isLeapYear) daysInMonth[1] = 29
    const validDay = day > 0 && day <= daysInMonth[month - 1]
    return validMonth && validDay
}

export function format24HourTo12Hour (time24: string): string {
  if (!/^\d{1,2}:\d{2}$/.test(time24)) { return 'N/A' }

  const [h, m] = time24.split(':').map(Number)
  if (h > 23 || h < 0 || m > 59 || m < 0) { return 'N/A' }

  const period = h >= 12 ? 'PM' : 'AM'
  const hour12 = h % 12 || 12

  return `${hour12}:${String(m).padStart(2, '0')} ${period}`
}
